import { Breadcrumb, Card, Col, Descriptions, Row, Space, Typography, Tabs } from "antd";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useProcurementStore from "store/procurement_store";
import { PROCUREMENT_TYPES } from "types";
import moment from "moment"
import Title from "antd/lib/typography/Title";
import { 
  DatabaseOutlined, 
  CloudServerOutlined, 
  GlobalOutlined, 
  EnvironmentOutlined 
} from "@ant-design/icons";

const ProcurementDetailsHeader = () => {
  const { procurement_header_data } = useProcurementStore((state) => ({
    procurement_header_data: state.procurement_header_data,
  }));
  
  const navigate = useNavigate();
  const handleBreadcrumbClick = (e, path,procurementName) => {
    e?.preventDefault();
    navigate(path,
      {
        state:{
          ...(procurementName ? { procurementName: procurementName } : {})
        }
      }
    );
  };

  const [searchParams] = useSearchParams();
  let stage_name = searchParams.get("stage");
  const PK = searchParams.get("PK");

  const breadcrumbsLabelMap={
    "Sizing":"ROBO"
  }

  // Stage navigation tabs
  const stageItems = [
    {
      key: "Sizing",
      label: (
        <span>
          <DatabaseOutlined />
          ROBO
        </span>
      ),
    },
    {
      key: "CommVault",
      label: (
        <span>
          <CloudServerOutlined />
          CommVault
        </span>
      ),
    },
    {
      key: "Network",
      label: (
        <span>
          <GlobalOutlined />
          Network
        </span>
      ),
    },
    {
      key: "Site",
      label: (
        <span>
          <EnvironmentOutlined />
          Site
        </span>
      ),
    },
  ];

  const handleStageChange = (key) => {
    navigate(`/procurement?PK=${PK}&stage=${key}`);
  };

  return (
    <Row gutter={[0,15]} >
      <Col span={18}>
        <Space>
          <Breadcrumb
            items={[
              {
                title: "All Orders",
                onClick: (e) => handleBreadcrumbClick(e, "/"),
                href: "/",
              },
              {
                title: procurement_header_data["procurement_name"],
                onClick: (e) => handleBreadcrumbClick(e, "/",procurement_header_data["procurement_name"]),
                href: `/${procurement_header_data["procurement_name"]}`
              },
            ]}
          />
        </Space>
      </Col>

      <Col span={24}>
        <div
          id="overview-table-section"
          style={{ border: "3px solid #f6f6f6", borderRadius: "10px" }}
        >
          <Descriptions bordered size="small" column={1} layout="horizontal">
            <Descriptions.Item label="Order Name">
              {procurement_header_data["procurement_name"]}
            </Descriptions.Item>
            {/* <Descriptions.Item label="Region">
              {procurement_header_data["region"]}
            </Descriptions.Item> */}
            <Descriptions.Item label="Data Center">
              {procurement_header_data["site_name"]}
            </Descriptions.Item>
            <Descriptions.Item label="Order Type">
              {procurement_header_data["procurement_type"]}
            </Descriptions.Item>
            {
              procurement_header_data["procurement_type"] === PROCUREMENT_TYPES.NEW &&
              <Descriptions.Item label="Cluster Type">
                {procurement_header_data["cluster_type"]}
              </Descriptions.Item>
            }

          </Descriptions>
        </div>
      </Col>

      {/* Stage Navigation Tabs */}
      <Col span={24}>
        <Tabs
          activeKey={stage_name}
          onChange={handleStageChange}
          items={stageItems}
          style={{
            marginTop: "8px",
          }}
          tabBarStyle={{
            marginBottom: 0,
            borderBottom: "1px solid #E5E7EB",
          }}
        />
      </Col>
    </Row>
  );
};

export default ProcurementDetailsHeader;
